import styled from 'styled-components';
import { FlexWrapper } from '../OurOffer/OurOffer.styles';

export const StyledFlexWrapper = styled(FlexWrapper)`
    width: 380px;
    margin: ${({ theme }) => theme.spacing * 10}px 0;
    @media screen and (max-width: 600px) {
        width: auto;
    }
`;
